import { render, staticRenderFns } from "./SystemVsInterviewerReccomendationChart.vue?vue&type=template&id=52885fdd&scoped=true&"
import script from "./SystemVsInterviewerReccomendationChart.vue?vue&type=script&lang=js&"
export * from "./SystemVsInterviewerReccomendationChart.vue?vue&type=script&lang=js&"
import style0 from "./SystemVsInterviewerReccomendationChart.vue?vue&type=style&index=0&id=52885fdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52885fdd",
  null
  
)

export default component.exports